import axios from 'axios';
import { authInterceptor } from './interceptors';

/*
Change baseURL to suit your project needs.
*/
const sevenIam = axios.create({
  baseURL: process.env.VUE_APP_IAM_BASEURL,
  timeout: 5000,
});

sevenIam.interceptors.request.use(
  authInterceptor,
  (error) => Promise.reject(error),
);

export default sevenIam;
